import { SVGProps } from "react";

export function LeftArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={1.5}
      {...props}
    >
      <path
        d="M1 11.219L21.47 11.219M1.02312 11.246L10.7133 21.47M10.7133 0.999972L1.02312 11.2239"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
